import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { TaskTypeService } from './task-type.service';
const service = new TaskTypeService();

export interface TaskTypeState {}

const TaskTypeStore: Module<TaskTypeState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getTaskTypes() {
         const response = await service.getTaskTypes();
         return response;
      },
   },
};

export default TaskTypeStore;
